import { AlertCircleIcon } from "@hugeicons-pro/core-stroke-rounded";
import { HugeiconsIcon } from "@hugeicons/react";
import { Show } from "shared/components";
import { formatConditionTitle } from "../utils";
import { ReactNode, useMemo } from "react";
import { Rule } from "shared/app/VerificationTemplate/slices/DecisionCriteria/slices/RuleCriteria/types";

// The reasons list only shows the rule's display title, so rules that differ
// by field_name/operator/threshold but resolve to the same title would render
// as visual duplicates. Collapse them by the rendered title.
const dedupeByTitle = (rules: Rule[]) => {
  const seen = new Set<string>();
  return rules.filter((rule) => {
    const title = formatConditionTitle(rule.field_name);
    if (seen.has(title)) return false;
    seen.add(title);
    return true;
  });
};

export const ReasonsSection = ({
  surfacedRules,
  isDecline,
  recommendationDetails
}: {
  isDecline: boolean;
  recommendationDetails?: ReactNode;
  surfacedRules: Rule[];
}) => {
  const reasons = useMemo(() => dedupeByTitle(surfacedRules), [surfacedRules]);

  return (
    <>
      <Show if={Boolean(recommendationDetails)}>
        <p className="text-base font-medium text-content-700 flex gap-3 items-center">
          {recommendationDetails}
        </p>
      </Show>

      <Show if={isDecline && reasons.length > 0}>
        <div className="space-y-2">
          {reasons.map((rule, index) => (
            <div
              key={`${rule.field_name}-${index}`}
              className="flex items-center gap-3"
            >
              <HugeiconsIcon
                icon={AlertCircleIcon}
                size={20}
                strokeWidth={1.5}
                className="text-content-300"
              />
              <span className="text-base font-medium text-content-700">
                {formatConditionTitle(rule.field_name)}
              </span>
            </div>
          ))}
        </div>
      </Show>
    </>
  );
};
